module.exports = __webpack_public_path__ + "img/granary.cf1ed8e7.jpg";